<template>
    <div>
        <h1>Server Form</h1>
    </div>
</template>

<script>
export default {
    
}
</script>